import { ILanguageItem, ISupportedLanguages } from 'models';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { SupportedLanguagesContext } from './SupportedLanguagesContext';

interface IProps {
  children: React.ReactNode;
}

const SupportedLanguagesContainer: React.FC<IProps> = ({ children }) => {
  const { generalConfig } = useSelector((state: RootState) => state.configReducer);
  const supportedLanguages = generalConfig?.supportLanguage as ISupportedLanguages;
  const languageOptions: ILanguageItem[] | undefined = useMemo(() => {
    const hasSupportedLanguages =
      !!supportedLanguages?.active && supportedLanguages?.data?.length > 0;
    if (hasSupportedLanguages) {
      const result = supportedLanguages?.data.reduce(
        (accumulator: ILanguageItem[], currentLanguage: ILanguageItem) => {
          const { code, snowCode, name, active } = currentLanguage;
          return active ? [...accumulator, { code, name, snowCode }] : [...accumulator];
        },
        [],
      );
      return result;
    }
    return [{ name: 'English', code: 'en' }];
  }, [supportedLanguages]);

  const value = useMemo(() => {
    return { languageOptions, supportedLanguages };
  }, [supportedLanguages, languageOptions])

  return <SupportedLanguagesContext.Provider value={value}>{children}</SupportedLanguagesContext.Provider>;
};

export default SupportedLanguagesContainer;
